import React, { createContext, useEffect, useState } from "react";
import { useSessionStorage } from "@mantine/hooks";

import { screens, errorScreen } from "../util/screens";
import { onlyUnique } from "../util/helpers";

const DEFAULT_SCREEN = screens.find((i) => i?.index === true);

export const ScreenContext = createContext();

export const ScreenContextProvider = (props) => {
  const [screen, _set_screen] = useSessionStorage({
    key: "screen",
    defaultValue: DEFAULT_SCREEN.path,
  });

  const [history, _set_history] = useSessionStorage({
    key: "screen-history",
    defaultValue: [],
  });

  useEffect(() => {
    if (screen === "Home") {
      _set_history([]);
    } else {
      _set_history((prev) => {
        return [...prev, screen].filter(onlyUnique);
      });
    }
  }, [screen]);

  const setScreen = (id) => {
    // find screen
    var screenObj = screens.find((x) => x.id === id);

    // error
    if (!screenObj) screenObj = errorScreen;

    _set_screen(screenObj.path);
  };

  const setPrevScreen = () => {
    history.pop();
    _set_screen(history.pop());
  };

  return (
    <ScreenContext.Provider value={{ screen, setScreen, setPrevScreen }}>
      {props.children}
    </ScreenContext.Provider>
  );
};
